<template>
  <div id="app">
    <transition name="loading">
      <div class='loading' v-if="!isLoaded">
        <div class="loader">Loading...</div>
      </div>
    </transition>
    <app-nav />
    <main-content />
    <app-footer />
  </div>
</template>

<script>
import LoadingView from '@/components/Loading'
import AppNav from '@/components/Header'
import Main from '@/components/Main'
import AppFooter from '@/components/Footer'
export default {
  name: 'App',
  components: {
    'loading-view': LoadingView,
    'app-nav': AppNav,
    'main-content': Main,
    'app-footer': AppFooter
  },
  computed: {
    isLoaded () {
      if (this.$store.state.loadedImages >= 4) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
@import "./assets/css/base.scss";
@import "./assets/css/loading.scss";

html {
  position: relative;
  min-height: 100%;
  font-size: 16px;
}

body {
  top: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', "ヒラギノ角ゴシック", 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ Pro W3',Roboto, 'メイリオ', Meiryo, sans-serif;
}

a {
  text-decoration: none;
}

p, li {
  font-size: 0.9em;
  @media screen and (min-width: 800px) {
    font-size: 1em;
  }
}

ul {
  padding: 0;
}

li {
  list-style-type: none;
}

dl {
  dd {
    margin: 0;
  }
}

.marker-line {
  background: linear-gradient(transparent 60%, $yellow 60%, $yellow 90%, transparent 90%);
  font-weight: bold;
  &.gray {
    background: linear-gradient(transparent 60%, $gray2 60%, $gray2 90%, transparent 90%);
  }
}

.loading-enter-active, .loading-leave-active {
  transition: all 2s;
  transition-delay: 1s;
  opacity: 1;
}

.loading-enter, .loading-leave-to {
  opacity: 0;
  background-color: white;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $black;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue